import { useMemo } from 'react';
import type { Feature, Placement } from '../components/PashaLanding/types';

export function useProjectFeatures(
  active: Placement,
  t: (key: string) => string
): { featuresLeft: Feature[]; featuresRight: Feature[] } {
  return useMemo(() => {
    const keyFeatures: Feature[] = [
      active.deadline && {
        name: `${t('pasha.opening_date')}: ${active.deadline}`,
        type: 'deadline'
      },
      active.buildingClass?.name && {
        name: `${t('pasha.building_class')}: ${active.buildingClass.name}`,
        type: 'buildingClass'
      }
    ].filter(Boolean) as Feature[];

    const extraFeatures: Feature[] = (active.facilities || []).map(f => ({
      name: f.name,
      iconUrl: f.iconUrl
    }));

    const allFeatures = [...keyFeatures, ...extraFeatures];
    const mid = Math.ceil(allFeatures.length / 2);

    return {
      featuresLeft: allFeatures.slice(0, mid),
      featuresRight: allFeatures.slice(mid)
    };
  }, [active, t]);
}
